import Box from "@mui/material/Box"
import PropTypes from "prop-types"

import { adminLiquidPageContentSx, adminPageSx } from "../adminStyles"

export default function AdminLiquidPage({ children, sx }) {
  return (
    <Box sx={{ ...adminLiquidPageContentSx, ...adminPageSx, ...sx }}>
      {children}
    </Box>
  )
}

AdminLiquidPage.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
}
